import { Text } from "@mantine/core";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCookiesSession } from "../../cookiesSession";
import constants from "../../utilities/constants";
import { useSelector } from "react-redux";
import { selectUserData } from "../../redux/selectors";
import { NAV_ACCESS, canNavAccess } from "../../utilities/navAccess";

const getAgreementsLandingUrl = (loginAsId) => {
  const candidates = [
    { access: NAV_ACCESS.dashboard, url: "/app/agreements_manager" },
    {
      access: NAV_ACCESS.notifications,
      url: "/app/agreements_manager/notifications",
    },
    {
      access: NAV_ACCESS.myAgreements,
      url: "/app/agreements_manager/agreements-list",
    },
    {
      access: NAV_ACCESS.newAgreement,
      url: "/app/agreements_manager/agreements/new",
    },
    {
      access: NAV_ACCESS.docsLocker,
      url: "/app/agreements_manager/docs-locker",
    },
    {
      access: NAV_ACCESS.documentChat,
      url: "/app/agreements_manager/document-chat",
    },
    {
      access: NAV_ACCESS.templates,
      url: "/app/agreements_manager/templates/agreement",
    },
    {
      access: NAV_ACCESS.obligations,
      url: "/app/agreements_manager/obligations",
    },
  ];

  const first = candidates.find(({ access }) =>
    canNavAccess(access, loginAsId),
  );
  return first?.url ?? "/app/agreements_manager";
};

const MODULE_ICONS = {
  agreement:
    "https://cdn1.iconfinder.com/data/icons/digital-banking-vol-1/80/contract__partnership__agreement__handshake_-512.png",
  obligation:
    "https://png.pngtree.com/png-clipart/20230424/original/pngtree-completed-task-line-icon-png-image_9093625.png",
  recovery: "https://cdn-icons-png.flaticon.com/512/3535/3535035.png",
};

function MainPageSection() {
  const navigate = useNavigate();
  const currentUser = useSelector(selectUserData) || {};
  const loginAsId = currentUser?.loginAs?.id;

  const userData = getCookiesSession("trueCounselUserDataMaster");
  if (!userData) {
    navigate("/login");
    return null;
  }

  const AppConfig = window.AppConfig;

  const activeModules = [
    {
      id: 1,
      name: "Agreements Manager",
      val: "agreement",
      icon: MODULE_ICONS.agreement,
      url: getAgreementsLandingUrl(loginAsId),
      internal: true,
    },
    {
      id: 2,
      name: "Obligations Manager",
      val: "obligation",
      icon: MODULE_ICONS.obligation,
      url: constants.obligationsUrl,
      internal: false,
    },
    {
      id: 3,
      name: "Receivables Manager",
      val: "recovery",
      icon: MODULE_ICONS.recovery,
      url: constants.recoveryUrl,
      internal: false,
    },
  ];

  const filteredModules = activeModules.filter(
    (module) => AppConfig?.modules?.[module.val],
  );

  return (
    <>
      <h2 className="mb-10 text-center text-5xl font-semibold leading-[5rem] tracking-[-0.04em] max-lg:text-2xl max-lg:leading-[1.875rem]">
        Hi-Tech | Hi-Touch Legal Solutions
      </h2>
      <section className="flex flex-wrap items-center justify-between gap-2 w-full max-w-5xl mx-auto">
        {filteredModules.map((module) => (
          <Link
            to={module.url}
            target="_blank"
            rel="noopener noreferrer"
            key={module.id}
            className="flex flex-col items-center justify-center"
          >
            <div className="p-3 bg-[#46BDE1] rounded-2xl">
              <img
                className="object-contain w-24 h-24 p-2"
                src={module.icon}
                alt={module.name}
              />
            </div>
            <Text className="mt-2 text-center text-2xl font-bold text-[#46BDE1]">
              {module.name}
            </Text>
          </Link>
        ))}
      </section>
      <h2 className="pt-10 text-center text-4xl font-semibold">
        Manage Your Legal Hygiene with Ease
      </h2>
    </>
  );
}

export default MainPageSection;
